export default __webpack_public_path__ + "static/media/categoria-astronaut.e20d8933.png";